import { render, staticRenderFns } from "./shortMessage_node_form.vue?vue&type=template&id=372ef38c&scoped=true&"
import script from "./shortMessage_node_form.vue?vue&type=script&lang=js&"
export * from "./shortMessage_node_form.vue?vue&type=script&lang=js&"
import style0 from "./shortMessage_node_form.vue?vue&type=style&index=0&id=372ef38c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ef38c",
  null
  
)

export default component.exports